import SocialIcons from "./SocialIcons";

const WrapLayoutSocialIcons = () => {
    return (
        <SocialIcons
            instagramUrl="https://www.instagram.com/giri.dresden/"
            // facebookUrl="https://www.facebook.com/giri.dresden"
            whatsappNumber="https://api.whatsapp.com/message/6435SJY6VTEHG1?autoload=1&app_absent=0"
            enableFloating={true}
            animationType="rotate"
            layout="vertical"
            fixed={true}
            position="bottomLeft" // 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'centerLeft' | 'centerRight'
            showTooltip={true}
        />
    );
};

export default WrapLayoutSocialIcons;